import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    console.error("Error caught by boundary:", error, errorInfo);
  }

  ProductionErrorPage() {
    const containerStyle = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#f8d7da",
      color: "#721c24",
      padding: "20px",
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
    };

    const boxStyle = {
      backgroundColor: "#ffffff",
      border: "1px solid #f5c6cb",
      borderRadius: "10px",
      padding: "30px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      maxWidth: "100%",
      maxHeight: "80%",
      overflow: "scroll"
    };

    const headingStyle = {
      fontSize: "24px",
      marginBottom: "10px",
    };

    const messageStyle = {
      fontSize: "16px",
    };

    return (
      <div style={containerStyle}>
        <div style={boxStyle}>
          <h1 style={headingStyle}>Oops! Something went wrong.</h1>
          <p style={messageStyle}>
            Please try refreshing the page or come back later. If the issue
            persists, contact support.
          </p>

          <h2 style={{ color: "#ff0000" }}>More info</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            <summary>Error Details</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      </div>
    );
  }

  // (<div style={{
  //           padding: '20px',
  //           margin: '20px',
  //           border: '1px solid #ff0000',
  //           borderRadius: '5px',
  //           backgroundColor: '#fff5f5'
  //         }}>
  //           <h2 style={{ color: '#ff0000' }}>Something went wrong.</h2>
  //           <details style={{ whiteSpace: 'pre-wrap' }}>
  //             <summary>Error Details</summary>
  //             {this.state.error && this.state.error.toString()}
  //             <br />
  //             {this.state.errorInfo && this.state.errorInfo.componentStack}
  //           </details>
  //         </div>)

  render() {
    if (this.state.hasError) {
      return this.ProductionErrorPage();
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
